// extracted by mini-css-extract-plugin
export var cartIconStyles = "tGs4b";
export var globalTop = "y62CR";
export var navigationStyles = "UAqPn";
export var proBadge = "FoFuZ";
export var projectsIcon = "cLL9_";